module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-9.0aaf18e4.png";